import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';

/**
 * Configuracion unica de FontAwesome.
 *
 * Por defecto la libreria inyecta su hoja de estilos en tiempo de ejecucion.
 * Con Vite eso llega despues del primer pintado y produce iconos gigantes
 * durante un instante, asi que la inyeccion se desactiva y la hoja se importa
 * arriba como cualquier otro CSS del proyecto.
 *
 * Los iconos se importan uno a uno donde se usan, nunca con `library.add()`
 * masivo: el registro global obliga al empaquetador a incluir el paquete
 * entero y anula el arbol de dependencias. Ver ADR-019.
 */
config.autoAddCss = false;
